<div class="w-100 float-left text-13x">

    <div class="w-100 float-left v-align relative" (click)="clicked()">
        <!-- <h5 class="medium float-left"> Employees </h5> -->
        <div class="b-b pb-2 w-100 mb-3 float-left align-v-center">
            <h5 class="medium m-0">{{'empType' | translate}}</h5>
            <div style="flex-grow: 1;"></div>
            <button class="btn btn-primary float-right mr-3" name="addEmpType" (click)="addDesignation()">
                {{'addEmpType' | translate}}
            </button>
            <!-- <button class="btn btn-secondary float-right" (click)="empActions(!hide)"> Action </button> -->
        </div>


    </div>


    <!-- DESIGNATION DETAILS GRID -->
    <div class="w-100 float-left mt-3">
        <div class="light-bg w-100 float-left p-2 grid-details" (click)="clicked()">

            <div class="col-lg-3 col-md-1 col-sm-1 col-xs-1 float-left">
                <h6 class="mb-lg-0 medium"> {{'name' | translate}} </h6>
            </div>
            <div class="col-lg-3 col-md-1 col-sm-1 col-xs-1 float-left">
                <h6 class="mb-lg-0 medium"> {{'code' | translate}} </h6>
            </div>
            <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left">
                <h6 class="mb-lg-0 medium"> {{'level' | translate}} </h6>
            </div>

            <div class="col-lg-1 col-md-1 col-sm-1 col-xs-1 float-left text-center">
                <h6 class="mb-lg-0 medium"> {{'action' | translate}} </h6>
            </div>
        </div>
        <ng-container *ngIf="mgrdata.length > 0">
            <div class="w-100 float-left p-md-2 grid-details"
                 *ngFor="let mgr of mgrdata; let i=index">

                <div class="col-lg-3 col-md-1 col-sm-1 col-xs-1 float-left">
                    <h6 class="mb-lg-0 text-truncate"> {{mgr.name}} </h6>
                </div>
                <div class="col-lg-3 col-md-1 col-sm-1 col-xs-1 float-left">
                    <h6 class="mb-lg-0 text-truncate"> {{mgr.code}} </h6>
                </div>
                <div class="col-lg-2 col-md-1 col-sm-1 col-xs-1 float-left">
                    <h6 class="mb-lg-0 text-truncate"> {{mgr.level}} </h6>
                </div>

                <div class="col-lg-1 col-md-1 col-sm-1 col-xs-1 float-left text-center relative">
                    <h6 class="mb-lg-0" (click)="empTableActions(i)" ngbTooltip="{{'clickForMoreOption' | translate}}">
                        <i class="fa fa-ellipsis-h"></i>
                    </h6>

                    <div class="empActions m-t-nsmd" *ngIf="i == trackHides">
                        <!-- <ngbd-popover-container></ngbd-popover-container> -->
                        <i class="fa fa-caret-up caret-up"></i>
                        <ul class="m-0 p-0">
                            <li (click)="editDesignation(mgr)"><i class="fa fa-pencil mr-2"></i> {{'edit' | translate}}
                            </li>
                            <li (click)="deleteDesg(mgr)"><i class="fa fa-trash mr-2"></i> {{'delete' | translate}}</li>

                        </ul>
                    </div>
                </div>
            </div>
        </ng-container>
        <ng-container *ngIf="mgrdata.length == 0">
            <div class="w-100 float-left min-h2 relative" *ngIf="showLoading">
                <!-- <div style="position: fixed; top: 50%; left: 50%; transform: translate(-50%, -50%); text-align: center">
      
                    <img src="./assets/img/load.gif" alt="loading" width="80px">
                
            </div> -->
                <div class="loader-div">
                    <!-- <img src="assets/images/loader.gif" [ngStyle]="{'width':'100px'}" alt="loading"> -->
                    <div class="loader-gif"></div>
                </div>
            </div>
            <div class="w-100 float-left p-4 grid-details" *ngIf="!showLoading">
                <p class="text-center m-0 w-100 medium">{{'noResultFound' | translate}}</p>
            </div>
        </ng-container>

        <!-- PAGINATION -->
        <div class="w-100 float-left my-4 light-bg p-3 align-v-center" (click)="clicked()">
            <h6 class="float-left mb-0"> {{((page-1)*pageSize)+1}} - {{pageSize*(page-1)+mgrPageData.numberOfElements}}
                {{'itemsOf' | translate}} {{mgrPageData.totalElements}} </h6>
            <div class="float-left ml-2 align-v-center">
                <label class="m-0 float-left">{{'showItemsPerPage' | translate}}</label>
                <select class="form-control float-left w-auto ml-2 mb-0" name="pageSizeEmpType" [(ngModel)]="pageSize"
                        (change)="OnPageSizeChanged($event.target.value)">
                    <option value="10">10</option>
                    <option value="20">20</option>
                    <option value="30">30</option>
                </select>
            </div>
            <div style="flex-grow: 1;"></div>
            <ngb-pagination [collectionSize]="collectionSize" [rotate]="true" [maxSize]="5" [pageSize]="pageSize"
                            [ellipses]="false"
                            [(page)]="page" [boundaryLinks]="true" (pageChange)="onPageChange($event)"
                            class="float-right"></ngb-pagination>
            <div (click)="onRefresh()" data-toggle="tooltip" data-placement="bottom" title="Refresh"
                 style="margin-right:1px; margin-left:10px;cursor: pointer;"><i class="fa fa-refresh"
                                                                                aria-hidden="true"></i></div>
        </div>
    </div>

</div>



// WEBPACK FOOTER //
// ./src/app/tools/mgrLevelList.html